import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <section id="sobre-nosotros" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/df0bfac40742417256e70c9e559b8cca.jpg"
                alt="Nuestro equipo de trabajo"
                className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500"
              />
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-2 h-2 bg-black rounded-full"></div>
              <span className="text-xs font-bold tracking-widest text-gray-600">{t('about_label')}</span>
            </div>
            
            <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              {t('about_title')}
            </h2>
            
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              {t('about_text_1')}
            </p>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              {t('about_text_2')}
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8">
              <div>
                <div className="text-4xl font-bold text-orange-600 mb-2">15+</div>
                <div className="text-sm text-gray-600 uppercase tracking-wide">{t('about_stat_1')}</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-orange-600 mb-2">500+</div>
                <div className="text-sm text-gray-600 uppercase tracking-wide">{t('about_stat_2')}</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-orange-600 mb-2">100%</div>
                <div className="text-sm text-gray-600 uppercase tracking-wide">{t('about_stat_3')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
